export default {"src":"/_next/static/media/SIGN_AGREEMENT_ICON_WHITE.3aec2126.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};